import { Component, Input, HostListener } from '@angular/core';
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: 'wm-app-my-applications-status-pill',
  template: `
@if (!isMobileDevice) {
  <span
    class="my-applications-status-pill"
    [style.background]="statusStyle.bg"
    [style.color]="statusStyle.color"
  >
    {{ row?.applicantStatus ? row?.applicantStatus : row?.inspectionStatus }}
  </span>
} @else {
  <div
    style="display:flex;justify-content:center;align-items:center;"
    [style.width]="row?.applicantStatus ? '70px' : '100px'"
  >
    @if (statusIcon === 'warning') {
      <div class="warning-circle">
        <mat-icon class="warning-icon">warning_amber</mat-icon>
      </div>
    } @else {
      <mat-icon
        [style.color]="iconColor"
        [attr.aria-label]="row?.applicantStatus || row?.inspectionStatus"
      >
        {{ statusIcon }}
      </mat-icon>
    }
  </div>

}  `,
  styles: [`
    .my-applications-status-pill {
      font-size: 12px;
      padding: 2px 10px;
      border-radius: 12px;
      font-weight: 500;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      width:100px;
    }
    mat-icon {
  font-size: 21px;
  width: 20px;
  height: 20px;
}

.warning-circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #ED6C02;
  display: flex;
  align-items: center;
  justify-content: center;
}

.warning-icon {
  color: white !important;
  font-size: 12px !important;
  width: 12px !important;
  height: 12px !important;
  line-height: 12px !important;
}
    
  `],
  imports: [MatIcon],
})
export class WorkflowJanusStatusPillComponent {
  @Input() row!: any;

  // Start code added by Sanchit on 27-03-2026
  private readonly statusStyles: Record<string, { bg: string; color: string }> = {
    // 'Incomplete': { bg: 'rgba(211, 47, 47, 1)', color: 'white' },
    // 'In Progress': { bg: 'rgba(211, 47, 47, 1)', color: 'white' },
    // 'Complete': { bg: 'rgba(46, 125, 50, 1)', color: 'white' },
    // 'Voided': { bg: '#9E9E9E', color: 'white' },
    // 'Rejected': { bg: 'rgba(211, 47, 47, 1)', color: 'white' },
    // 'Discarded': { bg: '#9E9E9E', color: 'white' },
    // 'Expired': { bg: '#ff5722', color: 'white' },
    // 'Locked': { bg: '#9E9E9E', color: 'white' },
    // 'Withdrawn': { bg: '#9C27B0', color: 'white' }
    'Complete': { bg: '#2E7D32', color: 'white' },
    'Incomplete': { bg: '#D32F2F', color: 'white' },
    'Action Needed': { bg: '#ED6C02', color: 'white' },
    'In Progress': { bg: '#1976D2', color: 'white' },
    'Voided': { bg: '#9E9E9E', color: 'white' }
  };

  private readonly inspectionStyles: Record<string, { bg: string; color: string }> = {
    'Success': { bg: '#2E7D32', color: 'white' },
    'Action Required': { bg: '#D32F2F', color: 'white' },
    'N/A': { bg: '#BDBDBD', color: 'white' }
  };

  isMobileDevice = window.innerWidth <= 600;

  @HostListener('window:resize')
  onResize() {
    this.isMobileDevice = window.innerWidth <= 600;
  }
  get statusStyle() {
    const inspectionValue = this.row?.inspectionStatus;
    const applicantValue = this.row?.applicantStatus;

    if (!applicantValue && inspectionValue) {
      const value = inspectionValue?.toString().trim().toLowerCase();

      let mappedValue = value;

      if (value === 'n/a' || value === 'na') mappedValue = 'N/A';
      else if (value === 'success' || value === 'complete') mappedValue = 'Success';
      else if (value === 'action required' || value === 'needed') mappedValue = 'Action Required';

      return this.inspectionStyles[mappedValue] || {
        bg: '#E0E0E0',
        color: 'white'
      };
    }

    if (applicantValue) {
      return this.statusStyles[applicantValue] || {
        bg: '#E0E0E0',
        color: 'white'
      };
    }

    return {
      bg: '#E0E0E0',
      color: 'white'
    };
  }
  // End code added by Sanchit on 27-03-2026
  get statusIcon(): string {
    const status = this.row?.applicantStatus || this.row?.inspectionStatus;

    switch (status) {
      case 'Complete':
      case 'Success':
        return 'check_circle';

      case 'Incomplete':
      case 'Action Required':
        return 'error';

      case 'Action Needed':
        return 'warning';

      case 'Voided':
      case 'N/A':
        return 'remove_circle';

      default:
        return 'remove_circle';
    }
  }
  get iconColor(): string {
    const status = this.row?.applicantStatus || this.row?.inspectionStatus;

    switch (status) {
      case 'Complete':
      case 'Success':
        return '#2E7D32'; // Green

      case 'Incomplete':
      case 'Action Required':
        return '#D32F2F'; // Red

      case 'Action Needed':
        return '#EF6C00'; // Orange

      case 'Voided':
      case 'N/A':
        return '#BDBDBD'; // Gray

      default:
        return '#BDBDBD';
    }
  }
}